<template>
  <div class="w-full flex flex-col pb-[12.5px]">
    <div
      class="w-[60px] min-h-1 max-h-1 bg-gray-800/20 rounded-xs self-center mt-2.5 mb-1.5"
    />

    <TallListItem icon="Check" @click="handleMarkAllAsRead">
      Mark all as read
    </TallListItem>
  </div>
</template>

<script setup lang="ts">
import { TallListItem } from '@/shared/components/Menu'
import { useMarkAllNotificationsAsReadMutation } from '@/shared/graphql/legacy/generated'
import { useDialog } from '@/shared/dialogs/useDialog'

const { close } = useDialog()
const { mutate: markAllAsRead } = useMarkAllNotificationsAsReadMutation()

const handleMarkAllAsRead = () => {
  markAllAsRead()
  close()
}
</script>
